import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

const ChatbotList = Loadable(lazy(() => import("./ChatbotList")));

export const chatbotRoutes = [
  {
    path: "/chats",
    exact: true,
    element: (
      <AuthorizedRoute allowFullAccess moduleKeys={[]}>
        <ChatbotList />
      </AuthorizedRoute>
    ),
  },
];
